module.exports = __webpack_public_path__ + "static/metaltraining2-e38e4b91b926fdf28d886ed87613b05a.png";